import React, { useEffect, useState } from 'react'; // useEffectとuseStateをインポート
import styled from 'styled-components';
import styles from './Animations.module.css';
import DescriptionParty from './DescriptionParty';
import BlogHighSchool from './BlogHighSchool';
import test1 from "../../img/test_1 (1).jpg";
import { device } from '../MainContents/Style/StyleDevice';


const primaryColor = '#b11b42'; // Dark Red
const secondaryColor = '#e25948'; // Bright Red/Orange
const lightTextColor = '#ffffff'; // White for contrast

const subtleGrey = '#f0f0f0'; // For background elements

const HeadingTitle = styled.div`
  text-align: left;
  font-size: 40px;
  font-weight: 500;
  line-height: 1.5em;
  color: #9b003f;
  margin-bottom: 30px;
  @media ${device.mobile} {
    font-size: 26px;
    margin-bottom: 10px;
    padding-left: 20px;
    padding-top: 18px;
  }
`;

const MidashiYobikou = styled.span`
    color: #9b003f;
    font-size: 3.5rem;
    font-style: italic;
    @media ${device.mobile} {
    font-size: 1.5rem;
  }
`;
const MidashiKakeru = styled.span`
    color: black;
    font-size: 3.5rem;
    font-style: italic;
    @media ${device.mobile} {
        font-size: 1.5rem;
    }
`;
const MidashiDaiichi = styled.span`
    color: orangered;
    font-size: 3.5rem;
    font-style: italic;
    @media ${device.mobile} {
        font-size: 1.5rem;
    }
`;
const MainBackColorGradient = styled.div`

    // background: linear-gradient(45deg, #9b003f 0%, orangered 100%);
background: linear-gradient(
  to bottom, 
  rgba(155, 0, 63, 1) 0%,   /* 上：赤（不透明） */
  rgba(255, 69, 0, 0.7) 50%, /* 中間：orangered（半透明） */
  rgba(255, 69, 0, 0) 100%   /* 下：orangered（完全透明） */
);
`;
const CollaborationBlocksContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: stretch;
    padding: 0 40px;
    @media ${device.mobile} {
        flex-direction: column;
        align-items: center;
        padding: 0 20px;
    }
`;
const schoolBlockBase = {
    flex: '1',
    minWidth: '45%',
    maxWidth: '550px',
    padding: '45px 35px',
    borderRadius: '15px',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: 'all 0.4s ease-in-out',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)', // Default shadow
    '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 18px 40px rgba(0, 0, 0, 0.25)',
    },
    zIndex: 2, // Ensure blocks are above any background patterns
    '@media (max-width: 768px)': {
        minWidth: '100%',
        maxWidth: '100%',
        marginBottom: '0px',
    }
};
const tosayobiBlockStyle = {
    ...schoolBlockBase,
    background: `linear-gradient(135deg, ${primaryColor} 0%, #a01a3c 100%)`, // Gradient for depth
    color: lightTextColor,
};

// Small decorative circles/patterns
const decorativeCircle = {
    position: 'absolute',
    borderRadius: '50%',
    opacity: '0.08',
    pointerEvents: 'none',
    zIndex: 1, // Behind content but within the block
}
const daiichiBlockStyle = {
    ...schoolBlockBase,
    background: `linear-gradient(135deg, ${secondaryColor} 0%, #d04d40 100%)`, // Gradient for depth
    color: lightTextColor,
};


const blockDescriptionStyle = {
    fontSize: '1.05em',
    lineHeight: '1.7',
    marginBottom: '30px',
    opacity: '0.95',
    '@media (max-width: 768px)': {
        fontSize: '0.05em',
    }
};


const blockTitleStyle = {
    fontSize: '2.4em',
    fontWeight: '700',
    marginBottom: '15px',
    borderBottom: `3px solid ${lightTextColor}`, // Underline effect
    paddingBottom: '10px',
    display: 'inline-block', // Makes underline fit content
    lineHeight: '1.2',
};
const emphasizeText = {
    fontWeight: 'bold',
    color: lightTextColor, // Ensure emphasized text stands out
    fontSize: '1.2em',

};

const featureItemStyle = {
    marginTop: '10px',
    marginBottom: '40px',
    fontSize: '1.05em',
    display: 'flex',
    alignItems: 'flex-start',
    lineHeight: '1.5',
    fontWeight: '300', // Lighter font weight for list items
    placeSelf: 'center',
};

const featureListStyle = {
    listStyle: 'none',
    padding: '0',
    margin: '0',
};
const checkIconStyle = {
    marginRight: '12px',
    color: lightTextColor,
    fontSize: '1.1em',
    // flexShrink: '0', // Prevent checkmark from shrinking
    transform: 'translateY(2px)', // Optical alignment
};
const plusSignStyle = {
    fontSize: '4.5em',
    fontWeight: 'bold',
    color: primaryColor, // Matches Tosayobi, indicating core strength
    textAlign: 'center',
    margin: '0 20px',
    alignSelf: 'center', // Centers it vertically in flex container
    '@media (max-width: 768px)': {
        margin: '30px 0',
        fontSize: '3.5em',
        order: 1, // 順序を指定してモバイルで真ん中に配置
    }
};
// NEW STYLE FOR THE INTRODUCTORY TEXT
const introTextStyle = {
    fontSize: '1.3em', // Slightly smaller to differentiate from main descriptions
    lineHeight: '1.6',
    marginBottom: '25px', // Add some space below it
    opacity: '0.9',
    backgroundColor: 'rgba(255, 255, 255, 0.1)', // Subtle white background for emphasis
    padding: '15px',
    borderRadius: '8px',
    borderLeft: `4px solid ${lightTextColor}`, // A subtle accent line
    fontWeight: '900', // Lighter weight for this descriptive text
    color: 'white',

};

// モバイル用のスタイルを追加
const MobilePlusSign = styled.div`
    font-size: 3.5em;
    font-weight: bold;
    color: ${primaryColor};
    text-align: center;
    margin: 30px 0;
    display: none;
    
    @media ${device.mobile} {
        display: block;
    }
`;

const DesktopPlusSign = styled.div`
    font-size: 4.5em;
    font-weight: bold;
    color: ${primaryColor};
    text-align: center;
    margin: 0 20px;
    align-self: center;
    
    @media ${device.mobile} {
        display: none;
    }
`;

const TosayobiBlock = styled.div`
    ${() => tosayobiBlockStyle}
    
    @media ${device.mobile} {
        order: 0;
    }
`;

const DaiichiBlock = styled.div`
    ${() => daiichiBlockStyle}
    
    @media ${device.mobile} {
        order: 2;
    }
`;

const HighSchoolIntroduction = () => {
    // アニメーションクラスを適用するかどうかを管理するstate
    const [animate, setAnimate] = useState(false); // コンポーネントがマウントされた（表示された）ときにアニメーションをトリガー
    useEffect(() => {
        // 画面に表示されたことを感知したらanimateをtrueにする
        setAnimate(true);
    }, []); // 空の依存配列は、コンポーネントが初回マウントされた時のみ実行されることを意味する
    return (
        <div>
            <div className="relative">
                <img src={test1} alt="Top Image" className="w-full opacity-60" />
                <HeadingTitle className="mb-5 absolute tracking-widest p-4 top-20 md:top-1/2" style={{ left: '10%' }}>
                    <MidashiYobikou>土佐塾予備校</MidashiYobikou>
                    <MidashiKakeru>×</MidashiKakeru>
                    <MidashiDaiichi>第一学院高等学校</MidashiDaiichi>
                </HeadingTitle>

                <div className="hidden md:block absolute  p-4 top-32 md:top-2/3" style={{ left: '10%' }}>
                    <p className="text-4xl tracking-widest font-bold">土佐塾予備校のノウハウで、</p>
                    <p className='text-4xl tracking-widest font-bold mt-3'>一人ひとりに寄り添う新たな学びの場</p>
                </div>
            </div>

            {/* 学校説明会の文章を追加 */}
            <DescriptionParty />

            <MainBackColorGradient>
                <div>
                    <h2 class='text-6xl text-white p-10'>
                        <span class='text-5xl  tracking-widest font-bold md:text-8xl'>TOSAYOBI高等学院</span><span class='text-4xl md:text-6xltracking-widest'>とは</span>
                        <p className='mt-20 text-4xl tracking-widest font-bold sm:text-2xl'>通信制だからできる、一人ひとりに合わせた学び方</p>
                        <div className="inline-grid">
                            <p className='mt-10 text-start text-2xl tracking-widest font-bold sm:text-base'>・大学受験対策も、高卒資格取得も、諦めない。</p>
                            <p className='mt-10 text-start text-2xl tracking-widest font-bold sm:text-base'>・土佐塾予備校の個別指導で、通信制高校の不安を解消。</p>
                            <p className='mt-10 text-start text-2xl tracking-widest font-bold sm:text-base'>・時間と場所にとらわれず、夢に向かって進める。</p>
                        </div>
                    </h2>
                </div>

            {/* TOSAYOBI BLOGを表示 */}
            <BlogHighSchool />

                <div
                    className={animate ? styles.fadeInUp : ''} // ここがポイント
                >

                    <CollaborationBlocksContainer>
                        <TosayobiBlock>
                            {/* Decorative elements within the block */}
                            <div style={{ ...decorativeCircle, width: '150px', height: '150px', top: '-70px', left: '-70px', background: lightTextColor }}></div>
                            <div style={{ ...decorativeCircle, width: '250px', height: '250px', bottom: '-120px', right: '-120px', background: lightTextColor }}></div>

                            <h2 style={blockTitleStyle}>土佐塾予備校</h2>
                            <p style={blockDescriptionStyle}>
                                生徒一人ひとりに適した学習・進学指導で高校生の学びをサポート。
                                <br />適切なマネジメントで<span style={emphasizeText}>一人ひとりに最適化した学びを実現</span>します。
                            </p>

                            <h3 style={{ ...blockTitleStyle, fontSize: '1.5em', borderBottom: '2px solid' }}>高校生活サポート</h3>
                            <ul style={featureListStyle}>

                                <li style={featureItemStyle}><span style={checkIconStyle}>✓&ensp;カウンセリング</span></li>
                                <li style={featureItemStyle}><span style={checkIconStyle}>✓&ensp;校内行事 (遠足・スポーツ大会など)</span></li>
                                <li style={featureItemStyle}><span style={checkIconStyle}>✓&ensp;保護者面談</span></li>
                                <li style={featureItemStyle}><span style={checkIconStyle}>✓&ensp;大学の説明会</span></li>
                                <li style={featureItemStyle}><span style={checkIconStyle}>✓&ensp;企業訪問・職場体験への参加</span></li>
                            </ul>

                            <h3 style={{ ...blockTitleStyle, fontSize: '1.5em', marginTop: '30px', borderBottom: '2px solid' }}>＋ 受験指導</h3>
                            <ul style={featureListStyle}>
                                <li style={featureItemStyle}><span style={checkIconStyle}>✓&ensp;学習マネジメント</span></li>
                                <li style={featureItemStyle}><span style={checkIconStyle}>✓&ensp;進学指導</span></li>
                                <li style={featureItemStyle}><span style={checkIconStyle}>✓&ensp;面接・小論文対策</span></li>
                                <li style={featureItemStyle}><span style={checkIconStyle}>✓&ensp;TOSAYOBIの夏期・冬期講習会への参加</span></li>
                                <li style={featureItemStyle}><span style={checkIconStyle}>✓&ensp;英語外部検定試験対策</span></li>
                                <li style={featureItemStyle}><span style={checkIconStyle}>✓&ensp;全国模試試験</span></li>
                            </ul>
                        </TosayobiBlock>

                        {/* デスクトップ用の × */}
                        <DesktopPlusSign>×</DesktopPlusSign>

                        {/* Daiichi Gakuin High School Section */}
                        <DaiichiBlock>
                            {/* Decorative elements within the block */}
                            <div style={{ ...decorativeCircle, width: '180px', height: '180px', top: '-90px', right: '-90px', background: lightTextColor }}></div>
                            <div style={{ ...decorativeCircle, width: '120px', height: '120px', bottom: '-60px', left: '-60px', background: lightTextColor }}></div>

                            <h2 style={blockTitleStyle}>第一学院高等学校</h2>
                            <p style={introTextStyle} className='text-left'>
                                第一学院高等学校は、全国にキャンパスを展開する<strong style={emphasizeText}>広域通信・単位制高等学校</strong>です。
                                生徒が日々の生活で感じる「<strong style={emphasizeText}>成長実感</strong>」を大切に、その「成長実感」を自信に変えて様々なチャレンジができるよう、生徒一人ひとりをサポートしています。
                            </p>
                            <p style={blockDescriptionStyle} className='text-left'>
                                通信制高校の特性を活かし、<span style={emphasizeText}>目標のための学習に専念できる環境</span>を提供。
                                <br />一人ひとりに合わせた柔軟な学び方で、高校卒業をサポートします。
                            </p>

                            <ul style={featureListStyle} className='text-left'>
                                <li style={featureItemStyle}>

                                    <div>
                                        <strong style={emphasizeText}><span style={checkIconStyle}>✓</span>年1回の通学で高校卒業。自分の時間を有効活用！</strong><br />
                                        <span style={{ fontSize: '0.9em', opacity: '0.9' }}>
                                            養父本校へのスクーリングは年１回のみ。やりたいことや夢に向かって、時間を有効に使えます。<br />
                                            <span style={{ fontWeight: 'bold' }}>※入学時期や単位習得状況により年２回以上となる場合もございます。</span>
                                        </span>
                                    </div>
                                </li>
                                <li style={featureItemStyle}>
                                    <div>
                                        <strong style={emphasizeText}><span style={checkIconStyle}>✓</span>授業やレポート提出はネットで完結。いつでもどこでも学習できる！</strong><br />
                                        <span style={{ fontSize: '0.9em', opacity: '0.9' }}>
                                            学習のメインは、映像授業の視聴とレポート学習。ネットで完結するのでスキマ時間に学習できます。
                                            また学習管理システムはタブレットやパソコン、スマートフォン等で学習できるマルチデバイス対応です。
                                        </span>
                                    </div>
                                </li>
                                <li style={featureItemStyle}>
                                    <div>
                                        <strong style={emphasizeText}><span style={checkIconStyle}>✓</span>通信でも担任制を導入</strong><br />
                                        <span style={{ fontSize: '0.9em', opacity: '0.9' }}>
                                            一人ひとりに担任がつき、日々の学習はもちろん、進路や生活の悩みも親身にサポートします。
                                        </span>
                                    </div>
                                </li>
                            </ul>
                            {/* <div className="mt-8 p-6 rounded-lg shadow-xl text-white" style={{ backgroundColor: '#cc4d00' }}> */}
                            <div className=" p-6 text-white" > {/* 濃いめのオレンジ色を直接指定 */}
                                <h3 className="w-full text-2xl font-bold mb-4 border-b-2 border-white pb-2 inline-block">卒業要件</h3>
                                <ul className="text-left list-disc list-inside text-lg leading-relaxed mb-6">
                                    <li><strong className="font-semibold">36か月以上</strong>の在籍期間</li>
                                    <li><strong className="font-semibold">30単位時間以上</strong>の特別活動</li>
                                    <li><strong className="font-semibold">必修科目を含めた74単位以上</strong>の単位習得</li>
                                </ul>
                                <p className="text-xl font-bold mb-3 text-left">単位はこれらの3つの要件を満たすことで認定されます。</p>
                                <ol className="text-left list-decimal list-inside text-lg leading-relaxed space-y-2">
                                    <li>レポート(報告課題)</li>
                                    <li>スクーリング(面接指導)</li>
                                    <li>テスト(単位認定試験)</li>
                                </ol>
                            </div>
                        </DaiichiBlock>

                        {/* モバイル用の × */}
                        <MobilePlusSign>×</MobilePlusSign>
                    </CollaborationBlocksContainer>
                </div>


            </MainBackColorGradient>
        </div>
    );
}

export default HighSchoolIntroduction;